import {TB_INFO_DELETED, TB_INFO_LOADED, TB_INFO_LOADING, TB_INFO_SAVED} from "./actionTypes";
import axios from "axios";
import {getConfig} from "./authActions";
import {returnErrors} from "./errorActions";
import {getSuccess} from "./successActions";
import {getPartnerId} from "../utils/authUtils";

export const loadTbInfo = () => (dispatch, getState) => {
    const partnerId = getPartnerId();
    const partnerIdParam = partnerId ? ("?partnerId=" + partnerId) : "";
    dispatch({type: TB_INFO_LOADING});
    axios
        .get(process.env.REACT_APP_API_URL + '/tbInfo' + partnerIdParam, getConfig(getState))
        .then(res =>
            dispatch({
                type: TB_INFO_LOADED,
                payload: res.data
            })
        )
        .catch(err => {
            dispatch(returnErrors(err));
        });
};

export const saveTbInfo = (body, callbackFunction) => (dispatch, getState) => {
    axios
        .post(process.env.REACT_APP_API_URL + '/tbInfo', body, getConfig(getState))
        .then(res =>
            dispatch({
                type: TB_INFO_SAVED,
                payload: res.data
            })
        )
        .then(() => callbackFunction && callbackFunction())
        .then(() => {
            dispatch(getSuccess({success: "ТБ статус сохранен"}))
        })
        .catch(err => {
            dispatch(returnErrors(err));
        });
};

export const deleteTbInfo = (id, callbackFunction) => (dispatch, getState) => {
    axios
        .delete(process.env.REACT_APP_API_URL + '/tbInfo/' + id, getConfig(getState))
        .then(res =>
            dispatch({
                type: TB_INFO_DELETED,
                payload: res.data
            })
        )
        .then(() => callbackFunction && callbackFunction())
        .then(() => {
            dispatch(getSuccess({success: "ТБ статус удален"}))
        })
        .catch(err => {
            dispatch(returnErrors(err));
        });
};